export const labels = {
  //Validation
  missingReferenceSheet:
    "לא ניתן למצוא את גליון העבודה 'Reference_sheet'. בכדי לנסות שוב, פתח את התוסף EY Canvas Bulk Update בחוברת עבודה חדשה.",
  descriptionError: "התיאור חורג ממגבלת {0} תווים",
  titleMissingError: "חסרה כותרת (חובה)",
  titlemaxLimitError: "הכותרת חורגת ממגבלת {0} התווים",
  userNotFromSelectedGroup: "לא ניתן להקצות בקשה גם לקבוצה וגם למשתמש",
  dueDateFormatError: "פורמט תאריך לא חוקי בתאריך היעד",
  fieldError:
    "לא ניתן היה לעדכן את ה- EY Canvas, מכיוון שבחלק מהרשומות היו שגיאות. לפרטים נוספים, בדוק את העמודה 'סטטוס' .",
  invalidColumn: "נתונים לא חוקיים ב-{0}",
  requiredColumn: "נדרש {0}",
  hashValueMissing:
    "הערך Hash נדרש לעדכון EY Canvas. בדוק את העמודה בגליון עבודה זה.",
  // Panel Headers
  engagement: "תיק ביקורת",
  select: "בחר",
  numberOfRecords: "מספר רשומות",
  dowanloadedOn: "הורד ב-",
  canvasUpdatesOn: "נשלח ל-EY Canvas לעיבוד",
  selectRecordsToUpdate: "בחר רשומות לעדכון",
  atlasWorkpaperIndexFramework: "EY Atlas: אינדקס לתיעוד ניירות העבודה",
  referenceOnly: "לצרכי סימוכין בלבד",
  columnsToUpdate: "עדכן את העמודות הללו",
  dueDateRequired: "נדרש תאריך יעד",
  requestNotAssignedError: "הקצה את הבקשה לקבוצה או למשתמש",
  infoText:
    "אינך יכול להפעיל את התוסף EY Canvas Bulk Update על מספר גיליונות באותה חוברת עבודה. בכדי לערוך פריט חדש או סביבת עבודה ב- EY Canvas, פתח את הכלי הזה בחוברת עבודה חדשה.",
  noUpdatesSaved: "לא נשמרו עדכונים",
  dummyLocalizationText: "Dummy Localization Text",
  unexpectedApiFailure: "כשל לא צפוי ב-API. בבקשה נסה שוב.",
  titleLengthExceeded: "הכותרת חורגת ממגבלת 500 התווים",
  DescriptionLengthExceeded: "התיאור חורג ממגבלת 4000 התווים",
  canvasDataEditor: "עורך נתונים ב- Canvas",
  selectanitemtoedit: "בחר אפשרות",
  editRequestMessage: "אילו בקשות תרצה לערוך?",
  selectRequestStatus: "בחר סטטוס בקשה אחד לפחות",
  selectRequestErrorMessage: "בחר סטטוס בקשה אחד לפחות",
  sheetWithSameNameExist:
    "כבר קיים גיליון בשם Input_sheet_{0}. אנא שנה את שם הגיליון כדי להמשיך.",
  engagementIdNotFound:
    "לא ניתן היה למצוא את ההתקשרות של ה- EY Canvas. בדוק את מזהה ההתקשרות ואשר שיש לך גישה לפתוח את ההתקשרות של ה- EY Canvas.",
  boundSheetAlreadyExist_1: "תוסף EY Canvas Bulk Update",
  boundSheetAlreadyExist_2: "אינו פועל בכרטיסיה זו",
  selectAnOperation: "מה ברצונך לעשות?",
  submit: "שלח",
  next: "הבא",
  eyCanvasEngagement: "בחר תיק ביקורת",
  search: "חפש",
  engagementNotSelected: "בחר תיק ביקורת",
  invalidEngagement: "בחר התקשרות חוקית",
  back: "חזור",
  noRecordsFound: "לא נמצאו רשומות",
  masterSheetNoteText:
    "הערה: גיליון זה נדרש בכדי שניתן יהיה להשתמש בתוסף EY Canvas Bulk Update.",
  informationText: "כלי זה מאפשר לך:",
  infoText1:
    "ערוך שמות מסמך ומשימות של EY Canvas עבור  Standardized Indexing, ו",
  infoText3: "צור וערוך פריטים אחרים ב-EY Canvas",
  infoTextforonlyAddClientRequest: "צור בקשות של לקוחות",
  yes: "כן",
  no: "לא",
  close: "סגור",
  ownedByEngagement: "אחראי תיק התקשרות זה",
  sharedToEngagement: "שותף עבור התקשרות זו",
  status: "סטטוס",
  statusId: "מזהה סטטוס",
  Continue: "המשך",
  updateCanvas: "עדכן את ה- EY Canvas",
  newDocumentName: "שם מסמך חדש",
  documentName: "שם המסמך",
  fileExt: "סיומת קובץ",
  shared: "שיתוף",
  docId: "מזהה מסמך",
  hash: "Hash",
  newPrefix: "קידומת חדשה",
  newSuffix: "סיומת חדשה",
  newTitle: "כותרת חדשה",
  taskPrefix: "קידומת משימה",
  taskSuffix: "סיומת משימה",
  taskTitle: "כותרת",
  taskType: "סוג משימה",
  taskTitleEditable: "כותרת המשימה ניתנת לעריכה",
  auditPhase: "שלב בביקורת",
  milestone: "אבן דרך",
  timePhase: "Time Phase",
  taskId: "מזהה משימה",
  populateMsg: "הזנת נתונים מה- EY Canvas לרשומות",
  updatingCanvas:
    "מעדכן את ה-  EY Canvas. <br /> פעולה זו עשויה להימשך מספר דקות.",
  loadingContent: "טוען תוכן",
  filenameRequired: "נדרש שם קובץ",
  excelError: "שגיאת נוסחת אקסל. תקן ונסה שוב.",
  specialCharacters: "שם המסמך אינו יכול להכיל */:<>\\?|" + '"',
  sameDocumentNameError: "שמות מסמכים חדשים וישנים זהים",
  docNameLimit: "שם המסמך לא יכול לעלות על 115 תווים",
  markValueInvalid: "ערך לא חוקי ב'עדכון ה- EY Canvas'. תקן ונסה שוב.",
  docAndHashNull:
    "מזהה מסמך ו/או ערך Hash נדרשים לצורך עדכון ה- EY Canvas. בדוק את העמודות האלה בגליון עבודה זה.",
  help: "עזרה",
  entityNotSelected: "בחר אפשרות להמשיך",
  AssignedToGroupInputMessageTitle: "בחר קבוצה (אופציונלי)",
  AssignedToGroupInputMessageDescription:
    "כדי להקצות לקבוצה שלמה בחר קבוצה והשאר את העמודה הבאה ריקה.",
  AssignedToUserInputMessageTitle: "בחר משתמש (אופציונלי)",
  AssignedToUserInputMessageDescription:
    "כדי להקצות למשתמש ספציפי בחר משתמש והשאר את העמודה הקודמת ריקה. המשתמשים רשומים לפי 'group.\n\n'. הערה: כל חברי הקבוצה יוכלו לראות את הבקשה. אם משתמש נמצא במספר קבוצות, בדוק שאתה בוחר באפשרות הנפתחת הנכונה.",
  apiServerExceptionError:
    "אירעה שגיאה בחיבור ל-EY Canvas. בבקשה נסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
  taskNameExceedsLimit:
    "חורג ממגבלת התווים (כותרת: 500 תווים; קידומת/סיומת: 50 תווים)",
  taskTypeUpdateNotAllowed: "לא ניתן לערוך את כותרת המשימה עבור סוג משימה זה",
  taskEmptyHashOrDocId:
    "מזהה משימה ו/או ערך Hash נדרשים לעדכון EY Canvas. בדוק את העמודות האלה בגליון עבודה זה.",
  taskTitleRequiredError: "כותרת המשימה נדרשת",
  sameTaskNameError: "שם המשימה החדשה והישנה (קידומת, סיומת, כותרת) זהים",
  universalUserPreferenceGetError:
    "אירעה שגיאה בהעדפות המשתמש בעת חיבור ל-EY Canvas. בבקשה נסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית",
  sameWorkbookMultipleSessionsError:
    "לא ניתן להפעיל מספר הפעלות עריכה בתוך אותה חוברת עבודה. בכדי לערוך פריט חדש או התקשרות ב- EY Canvas, פתח את הכלי הזה בחוברת עבודה חדשה.",
  errorMessageOnExcelUpdate:
    "לא ניתן היה לעדכן את ה- EY Canvas, מכיוון שבחלק מהרשומות היו שגיאות. בדוק את העמודה<b> סטטוס </b> לפרטים.",
  insufficientPermissionsError:
    "אין מספיק הרשאות. בדוק שאתה יכול לפתוח את ההתקשרות של ה-EY Canvas ונסה שוב.",
  ApiValidationErrorPreConditionFailedDocument:
    "לא ניתן היה לעדכן את ה- EY Canvas. ייתכן שחלק מהמסמכים הועברו או נמחקו. טען מחדש את הנתונים בחוברת עבודה חדשה ונסה שוב.",
  ApiValidationFailedWithErrorDocument:
    "לא ניתן היה לעדכן את EY Canvas, מכיוון שבחלק מהמסמכים היו שגיאות. בדוק את סטטוס העמודה לפרטים נוספים.",
  apiServerConnectError:
    "לא ניתן להתחבר ל-EY Canvas. ייתכן שתצטרך להיות ברשת EY בכדי לערוך את תיק הביקורת הזה. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
  apiServerError:
    "אירעה שגיאה בחיבור ל-EY Canvas. בבקשה נסה שוב. אם הבעיה נמשכת, אנא פנה לתמיכה הטכנית.",
  duplicateDocumentNameError: "שם מסמך כפול",
  APIValidationError:
    "לא ניתן היה לעדכן חלק מהרשומות ב-EY Canvas. בדוק את העמודה<b> סטטוס </b> לפרטים נוספים.",
  excelPopulatingMessage:
    "טעינת נתונים לאקסל. זה יכול לקחת כמה דקות. אל תלחץ על גליונות העבודה של Excel עד לסיום טעינת הנתונים.",
  generalError:
    "אירעה שגיאה. טען מחדש את התוסף EY Canvas Bulk Update ונסה שוב.",
  boundSheetAlreadyPopulated:
    "הפעלה נוספת אחרת של EY Canvas Bulk Update Add-in כבר התחילה בחוברת עבודה זו. נסה שוב בחוברת עבודה חדשה.",
  excelRenderIssue:
    "טעינת הנתונים מה- EY Canvas נקטעה כאשר לחצת על גליון עבודה של Excel. כדי לנסות שוב, התחל הפעלה של EY Canvas Excel Add-in בחוברת עבודה חדשה.",
  offlineModeLoadingMessage:
    "פתיחת תוסף EY Canvas Excel. זה יכול לקחת כמה דקות. אל תלחץ על גליונות העבודה של Excel עד לסיום טעינת הנתונים.",
  offlineModeUserClickError:
    "פתיחת התוספת EY Canvas Canvas Bulk Update הופסקה כאשר לחצת על גליון עבודה של Excel. כדי לנסות שוב, סגור ופתח מחדש את התוספת EY Canvas Bulk Update Add-in.",
  inActiveWorkbookError:
    "אירעה שגיאה בתוספת EY Canvas Bulk Update Add-in. פתח חוברת עבודה חדשה ונסה שוב. כדי למנוע שגיאה זו בעתיד, הימנע ממעבר בין חוברות עבודה בזמן הזנת הנתונים.",
  clientRequestTitleMissing: "חסרה כותרת (חובה)",
  addclinetRequestTagError:
    "הבקשה נוצרה ב-EY Canvas אך לא ניתן היה להוסיף תגים. ניתן להוסיף את התגים באופן ידני ב-EY Canvas.",
  editclinetRequestTagError:
    "לא ניתן היה לערוך תגים עבור בקשה זו. ניתן להוסיף או להסיר תגים באופן ידני ב-EY Canvas.",
  clinetRequestEYContactError:
    "לא ניתן לערוך את אנשי הקשר של EY עבור בקשה זו. ניתן להוסיף או להסיר ידנית אנשי קשר של EY ב-EY Canvas.",
  forbiddenByEYError:
    "הפעולה שננקטה נאסרה על ידי EY Information Security. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
  genericErrorMessage:
    "אירעה שגיאה בתוספת EY Canvas Bulk Update. פתח חוברת עבודה חדשה ונסה שוב.",
  itgcName: "שם בקרה כללית במערכות המידע (ITGC) (חובה)",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "שם בקרה (חובה)",
  frequency: "תדירות",
  designEffectiveness: "Design Effectiveness",
  controlType: "סוג בקרה",
  controlId: "מזהה בקרה",
  operatingEffectiveness: "אפקטיביות תפעולית",
  testing: "בודק",
  itControlId: "מזהה בקרת IT",
  isControlLowerRisk: "האם הבקרה בסיכון נמוך יותר?",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "אבן דרך (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "מזהה שלב זמן (Time phase)",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "קידומת",
  suffix: "סיומת",
  requiredTitle: "כותרת (חובה)",
  timePhaseRequired: "שלב זמן (נדרש)",
  taskGroupRequired: "קבוצת משימות (נדרש)",
  taskGroups: "קבוצת משימות",
  customizedDescription: "תיאור מותאם אישית",
  customizedDescriptionRequired: "תיאור מותאם אישית (חובה)",
  picSignOffRequired: "חתימת השותף האחראי על הביקורת (PIC)",
  eqrSignOffRequired: "חתימת שותף מלווה (EQR)",
  invalidDataInTags: "נתונים לא חוקיים בתגיות",
  taskTags: "תגים",
  editTaskAPIError:
    "לא ניתן היה לערוך תגיות עבור משימה זו. ניתן להוסיף או להסיר תגיות ידנית ב-EY Canvas.",
  engagementLDCVersionUpdateError:
    "עדכון זמין עבור תוסף EY Canvas Bulk Update. פתח את התוסף בחוברת עבודה חדשה לשמירת שינויים בשמות משימות.",
  module: "מודול",
  titleForMultiSelectInputMessage: "תפריט נפתח של בחירה מרובה",
  descriptionForMultiSelectInputMessage:
    "בחר אפשרות נפתחת אחת או יותר באמצעות חלונית התוספים מימין.",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "שם שדה",
  additionalInstructions: "הנחיות נוספות",
  toUploadAsDraft: "כדי להעלות כטיוטה",
  toSaveAsDraft: "כדי לשמור כטיוטה",
  toSendToClient: "לשלוח ללקוח",
  bulkUpdateAddIn: "תוסף EY Canvas Bulk Update",
  purpose: "מַטָרָה",
  guidance: "הנחיות",
  overView: "סקירה כללית של השדות",
  required: "נדרש",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "ניתן להשתמש בכלי זה לעריכת בקשות לקוח בכמות גדולה ב-EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "עיין בקישור EY Atlas לקבלת הדרכה נוספת כיצד להשתמש ב-EY Canvas Collaboration, כולל כיצד לערוך בכמות גדולה ולשלוח בקשות מ-EY Canvas Collaboration.",
  additionalInfo:
    "\u00B9 זהו השדה הנפתח לבחירה מרובה. כדי לערוך שדה זה, השתמש בתפריט הנפתח בחלונית התוספים מימין.",
  bulkUpdate: "\u00B2 ראה הנחיות נוספות",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "ניתן להשתמש בכלי זה להעלאה בכמות גדולה של משימות חדשות (OSTs) ל-EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "עיין בקישור EY Atlas לקבלת הדרכה נוספת בנוגע להקצאת משימות ב-EY Canvas, כולל כיצד להקצות משימות בכמות גדולה ב-EY Canvas.",
  additionalInfo:
    "\u00B9 זהו שדה נפתח לבחירה מרובה. כדי לערוך שדה זה, השתמש בתפריט הנפתח בחלונית התוספים מימין.",
};
export const instructionSheetDataForEditTasks = {
  purpose: "ניתן להשתמש בכלי זה לעריכה בכמות גדולה של משימות ב-EY Canvas.",
  guidanceHyperlinkforStandardizedIndexing: "אינדקס אחיד",
  guidanceforStandardizedIndexing:
    "ניתן להשתמש בכלי זה כדי להקל על אינדקס אחיד עבור משימות. לפרטים על אינדקס אחיד, עיין בקישור ההדרכה של EY Atlas.",
  guidanceHyperlinkForTaskAssignments: "הקצאות משימות",
  guidanceForTaskAssignments:
    "עיין בקישור EY Atlas לקבלת הדרכה נוספת על הקצאות משימות ב-EY Canvas, כולל כיצד להקצות משימות בכמות גדולה ב-EY Canvas.",
  additionalInfo:
    "\u00B9 זהו שדה נפתח לבחירה מרובה. כדי לערוך שדה זה, השתמש בתפריט הנפתח בחלונית התוספים מימין.",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת: \r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "קידומת",
    additionalInstructions:
      "השתמש בקידומת כדי לתמוך בשיטה למתן שמות לאינדקס אחיד (מגבלת 50 תווים)",
    required: "לא",
  },
  {
    count: "3",
    fieldName: "כותרת",
    additionalInstructions:
      "פתח שיטה למתן שמות שתעזור לך לנהל את המשימות שלך ביעילות (מגבלת 500 תווים)",
    required: "כן",
  },
  {
    count: "4",
    fieldName: "סיומת",
    additionalInstructions: "מגבלת 50 תווים",
    required: "לא",
  },
  {
    count: "5",
    fieldName: "שלב הזמן",
    additionalInstructions:
      "הקצה משימות לשלבי זמן כדי לתמוך בניהול פרויקטים יעיל",
    required: "כן",
  },
  {
    count: "6",
    fieldName: "קבוצת משימות",
    additionalInstructions:
      "ארגן את עבודת הביקורת לקבוצות משימות הניתנות לניהול. ניתן לערוך קבוצות משימות רק עבור OSTs.",
    required: "כן",
  },
  {
    count: "7",
    fieldName: "תיאור מותאם אישית",
    additionalInstructions: "תאר את הנהלים שיש לבצע עבור משימה זו",
    required: "לא",
  },
  {
    count: "8",
    fieldName: "תגים \u00B9",
    additionalInstructions:
      "תגיות הן תוויות מותאמות אישית הזמינות ב-EY Canvas שיכולות לסייע בניהול משימות",
    required: "לא",
  },
  {
    count: "9",
    fieldName: "חתימת השותף האחראי על הביקורת (PIC)",
    additionalInstructions:
      "ציין אם המשימה דורשת את חתימת השותף האחראי על הביקורת (PIC). (לא ניתן לערוך אם חתימת השותף האחראי על הביקורת (PIC) הוקצתה מתוך ה Knowledge)",
    required: "לא",
  },
  {
    count: "10",
    fieldName: "חתימת שותף מלווה (EQR)",
    additionalInstructions:
      "ציין אם המשימה דורשת את חתימת השותף המלווה (EQR). (לא ניתן לערוך אם חתימת השותף המלווה (EQR) הוקצתה מתוך ה Knowledge)",
    required: "לא",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר אתה לוחץ על הלחצן 'עדכן EY Canvas' בתוספת: \r\n - 'כן' יכלול את הבקשה ברשימה שנשלחה אל EY Canvas \r\n - 'לא' יחריג את הבקשה מהרשימה שנשלחה ל-EY Canvas",
    toSaveAsDraft: "כן",
    toSendToClient: "לא רלוונטי",
  },
  {
    count: "2",
    fieldName: "כותרת",
    additionalInstructions:
      "פתח ניהול שמות בכדי שיעזור לך לנהל ביעילות את כל הבקשות.",
    toSaveAsDraft: "כן",
    toSendToClient: "כן",
  },
  {
    count: "3",
    fieldName: "תיאור",
    additionalInstructions: "לתיאור יש מגבלה של 4,000 תווים",
    toSaveAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "4",
    fieldName: "הוקצה ל (קבוצה)",
    additionalInstructions:
      "הקצה את הבקשה למשתמש חיצוני או לקבוצה חיצונית.\r\n - כדי להקצות לקבוצה, בחר מתוך מוקצה ל (קבוצה) והשאר את העמודה הבאה ריקה.\r\n - כדי להקצות למשתמש ספציפי, בחר משתמש והשאר את העמודה הקודמת ריקה. המשתמשים רשומים לפי קבוצה.\r\n \r\nהערה: כל חברי הקבוצה יוכלו לראות את הבקשה. אם משתמש נמצא במספר קבוצות, בדוק שאתה בוחר באפשרות הנפתחת הנכונה.",
    toSaveAsDraft: "לא",
    toSendToClient: "אחד מאלה נדרש",
  },
  {
    count: "5",
    fieldName: "הוקצה ל (משתמש)",
    additionalInstructions: "",
    toSaveAsDraft: "לא",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "תאריך יעד (YYYY-MM-DD)",
    additionalInstructions:
      "יש לציין את תאריך היעד בפורמט YYYY-MM-DD. אם לא צוין תאריך יעד אך נבחר שלב זמן, תאריך היעד יקבע כברירת מחדל את תאריך הסיום של שלב הזמן.",
    toSaveAsDraft: "לא",
    toSendToClient: "כן \u00B2",
  },
  {
    count: "7",
    fieldName: "איש קשר EY \u00B9",
    additionalInstructions:
      "הוסף איש קשר של EY כדי ליידע את המשתמש החיצוני למי לפנות אם יש לו שאלות. איש הקשר של EY יקבל הודעה כאשר הלקוח יגיב לבקשה.",
    toSaveAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "8",
    fieldName: "תגים \u00B9",
    additionalInstructions:
      "תגים הם תוויות מותאמות אישית הזמינות ב-Collaboration במטרה לסייע בניהול הבקשות. אתה יכול לראות תגים שהוחלו על ידי הצוות ואת אלה שהוחלו על ידי משתמשים חיצוניים. התגים יסונכרנו בין Collaboration לבין EY Canvas Client Portal באופן אוטומטי.",
    toSaveAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "9",
    fieldName: "עדיפות",
    additionalInstructions:
      "הגדר עדיפות בקשה של גבוה או קריטי כדי לעזור ללקוח שלך לתעדף את הבקשות. אם לא צוין, עדיפות הבקשה תהיה כברירת מחדל לרגילה.",
    toSaveAsDraft: "לא",
    toSendToClient: "כן \u00B2",
  },
  {
    count: "10",
    fieldName: "שלב הזמן",
    additionalInstructions: "בחר שלב זמן ו/או תאריך יעד (ראה למעלה).",
    toSaveAsDraft: "לא",
    toSendToClient: "לא",
  },
];

export const instructionSheetData = {
  purpose:
    "ניתן להשתמש בכלי זה כדי להעלות בכמות גדולה בקשות לקוח חדשות ל-EY Canvas Collaboration. בקשות יועלו בסטטוס 'טיוטה'. לאחר מכן תוכל לשלוח בקשות בכמות גדולה ללקוח מה-EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "עיין בקישור EY Atlas לקבלת הדרכה נוספת כיצד להשתמש ב-EY Canvas Collaboration, כולל כיצד לערוך בכמות גדולה ולשלוח בקשות מ-EY Canvas Collaboration.",
  additionalInfo: "ראה הנחיות נוספות",
  bulkUpdate:
    "\u00B9 זהו שדה נפתח לבחירה מרובה. כדי לערוך שדה זה, השתמש בתפריט הנפתח בחלונית התוספים מימין.",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר אתה לוחץ על הלחצן 'עדכן EY Canvas' בתוספת: \r\n - 'כן' יכלול את הבקשה ברשימה שנשלחה אל EY Canvas \r\n - 'לא' יחריג את הבקשה מהרשימה שנשלחה ל-EY Canvas",
    toUploadAsDraft: "כן",
    toSendToClient: "לא רלוונטי",
  },
  {
    count: "2",
    fieldName: "כותרת (חובה)",
    additionalInstructions:
      "פתח ניהול שמות בכדי שיעזור לך לנהל ביעילות את כל הבקשות.",
    toUploadAsDraft: "כן",
    toSendToClient: "כן",
  },
  {
    count: "3",
    fieldName: "תיאור",
    additionalInstructions: "לתיאור יש מגבלה של 4,000 תווים",
    toUploadAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "4",
    fieldName: "הוקצה ל (קבוצה)",
    additionalInstructions:
      "הקצה את הבקשה למשתמש חיצוני או לקבוצה חיצונית.\r\n - כדי להקצות לקבוצה, בחר מתוך מוקצה ל (קבוצה) והשאר את העמודה הבאה ריקה.\r\n - כדי להקצות למשתמש ספציפי, בחר משתמש והשאר את העמודה הקודמת ריקה. המשתמשים רשומים לפי קבוצה.\r\n \r\nהערה: כל חברי הקבוצה יוכלו לראות את הבקשה. אם משתמש נמצא במספר קבוצות, בדוק שאתה בוחר באפשרות הנפתחת הנכונה.",
    toUploadAsDraft: "לא",
    toSendToClient: "אחד מאלה נדרש",
  },
  {
    count: "5",
    fieldName: "הוקצה ל (משתמש)",
    additionalInstructions: "",
    toUploadAsDraft: "לא",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "תאריך יעד (YYYY-MM-DD)",
    additionalInstructions:
      "יש לציין את תאריך היעד בפורמט YYYY-MM-DD. אם לא צוין תאריך יעד אך נבחר שלב זמן, תאריך היעד יקבע כברירת מחדל את תאריך הסיום של שלב הזמן.",
    toUploadAsDraft: "לא",
    toSendToClient: "כן \u00B2",
  },
  {
    count: "7",
    fieldName: "איש קשר EY \u00B9",
    additionalInstructions:
      "הוסף איש קשר של EY כדי ליידע את המשתמש החיצוני למי לפנות אם יש לו שאלות. איש הקשר של EY יקבל הודעה כאשר הלקוח יגיב לבקשה.",
    toUploadAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "8",
    fieldName: "תגים \u00B9",
    additionalInstructions:
      "תגים הם תוויות מותאמות אישית הזמינות ב-Collaboration במטרה לסייע בניהול הבקשות. אתה יכול לראות תגים שהוחלו על ידי הצוות ואת אלה שהוחלו על ידי משתמשים חיצוניים. התגים יסונכרנו בין Collaboration לבין EY Canvas Client Portal באופן אוטומטי.",
    toUploadAsDraft: "לא",
    toSendToClient: "לא",
  },
  {
    count: "9",
    fieldName: "עדיפות",
    additionalInstructions:
      "הגדר עדיפות בקשה של גבוה או קריטי כדי לעזור ללקוח שלך לתעדף את הבקשות. אם לא צוין, עדיפות הבקשה תהיה כברירת מחדל לרגילה.",
    toUploadAsDraft: "לא",
    toSendToClient: "כן \u00B2",
  },
  {
    count: "10",
    fieldName: "שלב הזמן",
    additionalInstructions: "בחר שלב זמן ו/או תאריך יעד (ראה למעלה).",
    toUploadAsDraft: "לא",
    toSendToClient: "לא",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose:
    "ניתן להשתמש בכלי זה לעריכה בכמות גדולה (bulk edit) של פרטי ITGC ב-EY Canvas.",
  additionalInfo:
    "\u002AI אם ערך כבר מצוין ב-EY Canvas, ניתן לשנות אותו אך לא למחוק אותו.",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002AI אם ערך כבר מצוין ב-EY Canvas, ניתן לשנות אותו אך לא למחוק אותו.",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת:\r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "כן",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "כן",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "ניתן להשתמש בכלי זה להעלאה בכמות גדולה של משימות חדשות (OSTs) ל-EY Canvas.",
  additionalInfo:
    "\u002AI אם ערך כבר מצוין ב-EY Canvas, ניתן לשנות אותו אך לא למחוק אותו.",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת: \r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "קידומת",
    additionalInstructions:
      "השתמש בקידומת כדי לתמוך בשיטה למתן שמות לאינדקס אחיד (מגבלת 50 תווים)",
    required: "לא",
  },
  {
    count: "3",
    fieldName: "כותרת",
    additionalInstructions:
      "פתח שיטה למתן שמות שתעזור לך לנהל את המשימות שלך ביעילות (מגבלת 500 תווים)",
    required: "כן",
  },
  {
    count: "4",
    fieldName: "סיומת",
    additionalInstructions: "מגבלת 50 תווים",
    required: "לא",
  },
  {
    count: "5",
    fieldName: "שלב הזמן",
    additionalInstructions:
      "הקצה משימות לשלבי זמן כדי לתמוך בניהול פרויקטים יעיל",
    required: "כן",
  },
  {
    count: "6",
    fieldName: "קבוצת משימות",
    additionalInstructions: "ארגן את העבודה לקבוצות משימות הניתנות לניהול",
    required: "כן",
  },
  {
    count: "7",
    fieldName: "תיאור מותאם אישית",
    additionalInstructions: "תאר את הנהלים שיש לבצע עבור משימה זו",
    required: "כן",
  },
  {
    count: "8",
    fieldName: "תגים \u00B9",
    additionalInstructions:
      "תגיות הן תוויות מותאמות אישית הזמינות ב-EY Canvas שיכולות לסייע בניהול משימות",
    required: "לא",
  },
  {
    count: "9",
    fieldName: "חתימת השותף האחראי על הביקורת (PIC)",
    additionalInstructions:
      "ציין האם המשימה דורשת חתימת שותף אחראי על הביקורת (PIC)",
    required: "לא",
  },
  {
    count: "10",
    fieldName: "חתימת שותף מלווה (EQR)",
    additionalInstructions: "ציין האם המשימה דורשת חתימת שותף מלווה (EQR)",
    required: "לא",
  },
];
export const instructionSheetStaticDataControl = {
  purpose:
    "ניתן להשתמש בכלי זה לעריכה בכמות גדולה (bulk edit) של פרטי הבקרה ב-EY Canvas.",
  additionalInfo:
    "\u002AI אם כבר צוין ערך ב-EY Canvas עבור שדה זה, ניתן לשנות אותו אך לא למחוק אותו.",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת: \r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "שם שלב הזמן (Time phase)",
    additionalInstructions: "500 character limit",
    required: "כן",
  },
  {
    count: "3",
    fieldName: "אבן דרך",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "כן",
  },
  {
    count: "4",
    fieldName: "תחילת תקופה",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "כן",
  },
  {
    count: "5",
    fieldName: "סוף תקופה",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "כן",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "לא",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת: \r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "שם בקרה כללית במערכות המידע (ITGC) (חובה)",
    additionalInstructions: "לשם ITGC יש מגבלה של 500 תווים",
    required: "כן",
  },
  {
    count: "3",
    fieldName: "תדירות",
    additionalInstructions: "בחר תדירות בקרה מהרשימה הנפתחת",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "Design Effectiveness",
    additionalInstructions:
      "אם הושלמו נהלי אפקטיביות תכנון (Design Effectiveness) , ציין את המסקנה (אפקטיבי או לא אפקטיבי)",
    required: "לא",
  },
  {
    count: "5",
    fieldName: "אפקטיביות תפעולית",
    additionalInstructions:
      "אם הושלמו נהלי אפקטיביות תפעולית (operating effectiveness), ציין את המסקנה (אפקטיבי או לא אפקטיבי)",
    required: "לא",
  },
  {
    count: "6",
    fieldName: "בודק",
    additionalInstructions: "ציין אם אנו מתכננים לבדוק בקרה זו",
    required: "לא",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "עדכן את ה- EY Canvas",
    additionalInstructions:
      "כאשר תלחץ על כפתור 'עדכן EY Canvas' בתוספת: \r\n - כפתור 'כן' יכלול את הרשומה ברשימה שנשלחה ל-EY Canvas \r\n - כפתור 'לא' תחריג את הרשומה מהרשימה שנשלחה ל-EY Canvas",
    required: "כן",
  },
  {
    count: "2",
    fieldName: "שם בקרה (חובה)",
    additionalInstructions: "לשם הבקרה יש מגבלה של 500 תווים",
    required: "כן",
  },
  {
    count: "3",
    fieldName: "תדירות",
    additionalInstructions: "בחר תדירות בקרה מהרשימה הנפתחת",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "סוג בקרה",
    additionalInstructions: "בחירת סוג בקרה מהרשימה הנפתחת",
    required: "No\u002A",
  },
  {
    count: "5",
    fieldName: "Design Effectiveness",
    additionalInstructions:
      "אם הושלמו נהלי אפקטיביות תכנון (Design Effectiveness) , ציין את המסקנה (אפקטיבי או לא אפקטיבי)",
    required: "לא",
  },
  {
    count: "6",
    fieldName: "אפקטיביות תפעולית",
    additionalInstructions:
      "אם הושלמו נהלי אפקטיביות תפעולית (operating effectiveness), ציין את המסקנה (אפקטיבי או לא אפקטיבי)",
    required: "לא",
  },
  {
    count: "7",
    fieldName: "בודק",
    additionalInstructions: "ציין אם אנו מתכננים לבדוק בקרה זו",
    required: "לא",
  },
  {
    count: "8",
    fieldName: "האם הבקרה בסיכון נמוך יותר?",
    additionalInstructions: "ציין אם הבקרה היא בסיכון נמוך יותר",
    required: "לא",
  },
];

export const errors = {
  14057: "שם מסמך כפול",
  14084: "שם המסמך אינו יכול להכיל */:<>\\?|" + '"',
  14085: "שם המסמך לא יכול לעלות על 115 תווים",
  14086: "DocService נכשל בעת עדכון פרטי המסמך.",
  14088: "שם מסמך כפול",
  5166: "לא ניתן לערוך את כותרת המשימה עבור סוג משימה זה",
  5170: "חורג ממגבלת התווים (כותרת: 500 תווים; קידומת/סיומת: 50 תווים)",
  5169: "חורג ממגבלת התווים (כותרת: 500 תווים; קידומת/סיומת: 50 תווים)",
  5047: "חורג ממגבלת התווים (כותרת: 500 תווים; קידומת/סיומת: 50 תווים)",
  5018: "המשימה נמחקה או נדחתה ב-EY Canvas",
  14071: "נדרש שם קובץ",
  14054: "נדרש שם קובץ",
  409: "שם מסמך כפול",
  21071: "ספירת בקשות הלקוח שנשלחו בגוף חורגת מהמגבלה המקסימלית המותרת.",
  21041: "הכותרת חורגת ממגבלת 500 התווים",
  21076: "נתונים לא חוקיים בתעדוף",
  21042: "התיאור חורג ממגבלת 4000 התווים",
  21072: "נתונים לא חוקיים בתאריך יעד",
  21027: "חסרה כותרת (חובה)",
  21039: "הקצה את הבקשה לקבוצה/משתמש חוקיים",
  21032: "הקצה את הבקשה לקבוצה/משתמש חוקיים",
  21034: "Client Group does not have active users",
  21035: "הבקשה לא נמצאה ב-EY Canvas",
  21036: "נתונים לא חוקיים בשלב הזמן",
  21057:
    "EY Contact אינו חבר בהתקשרות, אינו פעיל או שהוא מוגדר לצרכי אי תלות בלבד",
  21073:
    "נתון אחד או יותר בטעינת הבקשה אינו חוקי. אנא אמת את הנתונים ונסה שוב.",
  21074: "לא ניתן לשנות את הכותרת, התיאור או העדיפות עבור בקשות שהתקבלו",
  21075:
    "לא ניתן לשנות כותרת, תיאור, מוקצה ל (קבוצה), מוקצה ל(משתמש), תאריך יעד, עדיפות או שלב זמן עבור הבקשות שהתקבלו",
  21076: "Enum PriorityTypeId אינו מכיל 1, 2 או 3",
  21077: "ציין תאריך יעד בפורמט YYYY-MM-DD",
  21078:
    "הן הקבוצה והן המשתמש נדרשים שניהם בעת עדכון האפשרות 'הוקצה לקבוצה' או 'הוקצה למשתמש'",
  21079: "ציין תאריך יעד בפורמט YYYY-MM-DD",
  21080: "נדרש תאריך יעד , כאשר Timephase זמין",
  21081: "אנשי הקשר של EY אינם חוקיים או כוללים כפילויות",
  25000: "ציין שלב זמן (time phase)",
  26000: "ציין תאריך יעד בפורמט YYYY-MM-DD",
  84006: "נדרש שם בקרה כללית במערכות המידע (ITGC)",
  84007: "שם ITGC חורג ממגבלת 500 תווים",
  84008: "נתונים לא חוקיים בתדירות",
  84029: "נתונים לא חוקיים בתדירות",
  84010: "נתונים לא חוקיים באפקטיביות תכנון (Design Effectiveness)",
  84027: "נתונים לא תקינים בבדיקה",
  84028: "נתונים לא חוקיים בבדיקה",
  84031:
    "לא ניתן להסיק על אפקטיביות תפעולית (operating effectiveness) אם Testing = No",
  84032: "נתונים לא חוקיים באפקטיביות תכנון (Design Effectiveness)",
  84004: "מזהה בקרת IT לא חוקי",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "שם הבקרה חורג ממגבלת 500 תווים",
  83004: "מזהה בקרה לא חוקי",
  83006: "נדרש שם בקרה",
  83009: "נתונים לא חוקיים בתדירות",
  83010: "נתונים לא חוקיים בסוג הבקרה",
  83031: "נתונים לא חוקיים ב- IsIPEManuallyTested",
  83012: "נתונים לא חוקיים באפקטיביות תכנון (Design Effectiveness)",
  83033: "נתונים לא חוקיים באפקטיביות התפעולית (operating effectiveness)",
  83034: "נתונים לא חוקיים בבדיקה",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "קידומת חורגת ממגבלת 50 התווים",
  5170: "סיומת חורגת ממגבלת 50 התווים",
  5047: "הכותרת חורגת ממגבלת 500 התווים",
  5108: "התיאור חורג ממגבלת 4000 התווים",
  5059: "נתונים לא חוקיים בשלב הזמן (נדרש)",
  5111: "נתונים לא חוקיים בקבוצת משימות (נדרש)",
  5051: "נתונים לא חוקיים בקבוצת משימות (נדרש)",
  5019: "תיאור מותאם אישית (נדרש) נדרש",
  5103: "כותרת (נדרש) נדרשת",
  5104: "שלב זמן (נדרש) נדרש",
  5109: "קבוצת משימות (נדרש) נדרשת",
  5203: "נדרשת חתימת השותף האחראי על הביקורת (PIC)",
  5204: "נדרשת חתימת השותף המלווה (EQR)",
  5202: "לא ניתן לשנות קבוצת משימות",
  5168: "יש למלא את השדה 'כותרת' (נדרש)",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "היקף",
  2: "אסטרטגיית תת התהליך המהותי (SCOT)",
  3: "Walkthroughs",
  4: "טסטים על בקרות בתקופות ביניים",
  5: "בדיקות מבססות בתקופות ביניים",
  6: "Walkthroughs (תהליכי סוף השנה)",
  7: "טסטים על בקרות בסוף שנה",
  8: "בדיקות מבססות בסוף שנה",
  9: "מסקנה",
  10: "לא ישים",
  11: "ביצוע הביקורת",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "Post-interim project management",
};

export const clientRequestStatusType = {
  1: "טיוטה",
  2: "טיוטה",
  5: "טיוטה",
  10: "טיוטה",
  11: "טיוטה",
  14: "טיוטה",
  17: "טיוטה",
  6: "ממתין למענה",
  9: "ממתין למענה",
  13: "ממתין למענה",
  16: "ממתין למענה",
  20: "ממתין למענה",
  21: "ממתין למענה",
  27: "ממתין למענה",
  7: "התקבל",
  12: "התקבל",
  15: "התקבל",
  18: "התקבל",
  19: "התקבל",
  8: "התקבל",
  28: "התקבל",
};

export const filterAuditPhases = {
  1: "היקף ואסטרטגיה",
  2: "ביצוע הביקורת",
  3: "מסקנה",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "EDC",
  30: "UDP",
  31: "UDP",
  32: "EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "ממתין לסנכרון", //pending
  2: "נערך בצורה לא מקוונת", //offlineEdit
  3: "הורד", //downloaded
  4: "הועלה", //uploaded
  5: "קלט לא חוקי", //invalidInput
  6: "שגיאת שרת", //serverError
  7: "שגיאת API לא צפויה", //unexpectedAPIError
  8: "שגיאת אחזור לקוח", //clientFetchError
  9: "שגיאה לאחר עיבוד", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "עדכן את ה- EY Canvas",
  priority: "עדיפות",
  assignedToGroups: "הוקצה ל (קבוצה)",
  assignedToUsers: "הוקצה ל (משתמש)",
  eyContacts: "איש קשר של EY",
  tags: "תגים",
  timephases: "שלבי זמן",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "עדכן את ה- EY Canvas",
  timePhase: "Time Phase",
  taskGroup: "קבוצת משימות",
  tags: "תגים",
  timephasename: "שם שלב הזמן (Time phase)",
  startDate: "תחילת תקופה",
  endDate: "סוף תקופה",
  timePhaseId: "מזהה שלב זמן (Time phase)",
  taskGroupName: "שם קבוצת משימות",
  auditPhase: "שלב בביקורת",
  groupName: "שם הקבוצה",
  taskGroupId: "מזהה קבוצת משימות",
  tagDescription: "תיאור",
  tagGroup: "קבוצת תגים",
  tagLabel: "תָג",
  tagColor: "צבע",
  tagId: "מזהה תג",
  signOff: "חתימה",
  signOffValue: "ערך חתימה",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "כותרת (חובה)",
  clientRequestDescription: "תיאור",
  AssignedToGroup: "הוקצה ל (קבוצה)",
  AssignedToUser: "הוקצה ל (משתמש)",
  DueDate: "תאריך יעד (YYYY-MM-DD)",
  eyContact: "איש קשר של EY",
  tags: "תגים",
  priority: "עדיפות",
  requestGuid: "ClientRequest GUID",
  requestId: "ClientRequestID",
  statusID: "מזהה סטטוס",
  timephases: "Time Phase",
  requestHash: "בקשה מספר",
  requestHashSpace: "בקשה מספר",
  clientRequestTitleSpace: "כותרת (חובה)",
  clientRequestDescriptionSpace: "תיאור",
  AssignedToGroupSpace: "הוקצה ל (קבוצה)",
  AssignedToUserSpace: "הוקצה ל (משתמש)",
  DueDateSpace: "תאריך יעד (YYYY-MM-DD)",
  eyContactSpace: "איש קשר של EY",
  tagsSpace: "תגים",
  prioritySpace: "עֲדִיפוּת",
  timephasesSpace: "שלב הזמן",
  requestStatusId: "מזהה סטטוס בקשה",
  requestStatus: "מצב בקשה",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "שם עדיפות",
    priorityTypeId: "מזהה סוג עדיפות",
  },
  assignedToGroups: {
    group: "קבוצה",
    groupName: "שם הקבוצה",
    groupId: "מזהה קבוצה",
  },
  assignedToUsers: {
    groupMember: "חבר קבוצה",
    name: "שם",
    groupName: "שם הקבוצה",
    userId: "מזהה משתמש",
    groupId: "מזהה קבוצה",
  },
  eyContacts: {
    name: "שם",
    userId: "מזהה משתמש",
  },
  tags: {
    tagName: "תָג",
    colorCode: "צֶבַע",
    engagementTagName: "פירוט",
    engagementTagID: "מזהה תג",
  },
  timephases: {
    timePhaseName: "Time Phase",
    periodName: "שם שלב הזמן (Time phase)",
    startDate: "תחילת תקופה",
    dueDate: "סוף תקופה",
    timephaseId: "מזהה שלב זמן (Time phase)",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "נוֹרמָלִי",
  },
  {
    value: 3,
    label: "High",
  },
  {
    value: 4,
    label: "קריטי",
  },
];

export const ButtonOptions = [
  {
    label: "ערוך שמות מסמכים",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "צור טיוטת בקשות לקוח",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "ערוך בקשות של לקוחות",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "עריכת ITGC",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "ערוך משימות",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "ערוך בקרות",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "צור משימות (OSTs)",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "טיוטה",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "ממתין למענה",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "התקבל",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "התקבל",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "אָדוֹם",
    label: "אָדוֹם",
  },
  {
    value: "כתום",
    label: "כתום",
  },
  {
    value: "ירוק כחלחל",
    label: "ירוק כחלחל",
  },
  {
    value: "כְּחוֹל",
    label: "כְּחוֹל",
  },
  {
    value: "סָגוֹל",
    label: "סָגוֹל",
  },
  {
    value: "ירוק",
    label: "ירוק",
  },
  {
    value: "צהוב",
    label: "צהוב",
  },
  {
    value: "אפור",
    label: "אפור",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "הרבה פעמים ביום",
  },
  {
    id: 2,
    value: 2,
    label: "יומי",
  },
  {
    id: 3,
    value: 3,
    label: "שבועי",
  },
  {
    id: 4,
    value: 4,
    label: "חודשי",
  },
  {
    id: 5,
    value: 5,
    label: "רבעוני",
  },
  {
    id: 6,
    value: 6,
    label: "שנתי",
  },
  {
    id: 8,
    value: 8,
    label: "אחרים",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "יעיל",
  },
  {
    id: 2,
    value: 2,
    label: "לא יעיל",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "יעיל",
  },
  {
    id: false,
    value: false,
    label: "לא יעיל",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "לא נכון",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "כן",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "לא",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "בקרת אפליקציית IT",
  },
  {
    id: 2,
    value: 2,
    label: "IT Dependent Manual Control",
  },
  {
    id: 3,
    value: 3,
    label: "מונעת ידנית",
  },
  {
    id: 4,
    value: 4,
    label: "בקרה ידנית מגלה",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "Post-interim project management",
  },
  {
    id: 3,
    value: 3,
    label: "Walkthroughs",
  },
  {
    id: 4,
    value: 4,
    label: "טסטים על בקרות בתקופות ביניים",
  },
  {
    id: 5,
    value: 5,
    label: "בדיקות מבססות בתקופות ביניים",
  },
  {
    id: 6,
    value: 6,
    label: "Walkthroughs (תהליכי סוף השנה)",
  },
  {
    id: 7,
    value: 7,
    label: "טסטים על בקרות בסוף שנה",
  },
  {
    id: 8,
    value: 8,
    label: "בדיקות מבססות בסוף שנה",
  },
  {
    id: 11,
    value: 11,
    label: "ביצוע הביקורת",
  },
  {
    id: 9,
    value: 9,
    label: "מסקנה",
  },
  {
    id: 10,
    value: 10,
    label: "לא רלוונטי",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
